import {gsap} from "gsap";
import {HTH} from "../HTH";
import {HTHHelper} from "../utils/HTHHelper";
import {ISymbolData, HTHSymbol, HTHSymbolStates} from "./HTHSymbol";

export class HTHScatterSymbol extends HTHSymbol {
    private _spine: PIXI.spine.Spine;
    // private _spine: PIXI.Sprite;
    private _isCollected:boolean = false;
    private _isAnticipationPlaying:boolean;

    protected addSpine(): void {
        if (this._spine) {
            return;
        }
        // this._spine = new PIXI.spine.Spine(HTH.assetLoader.getSpineAsset("SC"));
        //HTHHelper.playSpineWithTimeline(this._spine, 0, "normal");
        //this._spine.autoUpdate=false;
        //this._spine.state.setAnimation(0, "normal", false);
        this._spine = new PIXI.spine.Spine(HTH.assetLoader.getSpineAsset("SC"));
        this._spine.state.setAnimation(0,"idle",false);
        this.addChild(this._spine);

    }

    public getStateAnimation(state: HTHSymbolStates = HTHSymbolStates.NORMAL, duration: number = 0): gsap.core.Timeline {
        if (this.symbolState === state) {
            return gsap.timeline();
        }
        const tl: gsap.core.Timeline = gsap.timeline();
        return tl;
    }

    constructor(symbolData: ISymbolData, state: HTHSymbolStates = HTHSymbolStates.NORMAL) {
        super(symbolData);
        this.addSpine();
        this.symbolState = HTHSymbolStates.NORMAL;
        this._isAnticipationPlaying=false;
    }

    public remove(): void {
        if (this._spine) {
            this._spine.destroy();
        }
        if (this.parent) {
            this.parent.removeChild(this);
        }
        this.destroy({children: true});
        this.isRemoved = true;
    }

    public playSpineAnim(animName: string,includeInTl:boolean, toLoop: boolean, speed: number = 1): gsap.core.Timeline {
        const playTl: gsap.core.Timeline = gsap.timeline();

        if(includeInTl){
            playTl.add(HTHHelper.playSpineWithTimeline(this._spine, 0, animName));
        }
        else{
            if(animName==="anticipation"){
                this._isAnticipationPlaying=true;
            }
            playTl.add(() => {
                this._spine!.autoUpdate = true;
                this._spine.state.setAnimation(0, animName, toLoop).timeScale = speed;
            });
        }

        return playTl;
    }

    public reset() {
        // this._spine.autoUpdate = false;
        //HTHHelper.resetSpineItem(this._spine);
    }

    public removeAndDestroy(): void {
        if (this.parent) {
            this.parent.removeChild(this);
        }
        this.destroy({children: true});
        this.isRemoved = true;
    }


    get isCollected(): boolean {
        return this._isCollected;
    }

    set isCollected(value: boolean) {
        this._isCollected = value;
    }

    get isAnticipationPlaying(): boolean {
        return this._isAnticipationPlaying;
    }

    set isAnticipationPlaying(value: boolean) {
        this._isAnticipationPlaying = value;
    }
}